import { get, post } from './http-calls';

export const getqcJobs = async (start, end) => {
    let res = await get(`QCSheet/GetQCJobsDashboard?startDate=${start}&endDate=${end}`, { useAuthToken: true });
    return res;
};
